export default __webpack_public_path__ + "static/home-hero-94afeb2800dd77a2169d07aeb69ccd66.png";